import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { httpRequest } from "../redux/Action"; 
import { API_END_POINTS } from "../api/ApiEndPonts"; 

function Subject() {
  const dispatch = useDispatch();

  const [subjects, setSubjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentValue, setCurrentValue] = useState("");
  const [editIdx, setEditIdx] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ GET SUBJECTS
  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = () => {
    dispatch(
      httpRequest({
        key: API_END_POINTS.getAllSubjects.KEY,
        onSuccess: (res) => {
          console.log("Subjects:", res);
          setSubjects(res.data || []);
        },
        onError: (err) => {
          console.log("Fetch Error:", err);
        },
      })
    );
  };

  const toggleModal = (idx = null) => {
    if (idx !== null) {
      setEditIdx(idx);
      setCurrentValue(subjects[idx].title);
    } else {
      setEditIdx(null);
      setCurrentValue("");
    }
    setIsModalOpen(!isModalOpen);
  };

  // ✅ ADD + UPDATE
const saveSubject = () => {
  if (!currentValue.trim()) return;

  if (editIdx !== null) {
    // ✅ Extract the ID from the subject object
    const id = subjects[editIdx]?._id;
    
    console.log("Updating subject ID:", id);
    console.log("Subject data:", subjects[editIdx]);
    
    if (!id) {
      console.error("No ID found for subject:", subjects[editIdx]);
      return;
    }

    dispatch(
      httpRequest({
        key: API_END_POINTS.updateSubject.KEY,
        params: { id },          
        data: { title: currentValue },

        onSuccess: () => {
          fetchSubjects();  // Refresh the list
          setIsModalOpen(false);
          setCurrentValue('');
          setEditIdx(null);
        },

        onError: (err) => {
          console.log("Update Error:", err);
          console.log("Failed to update subject with ID:", id);
          console.log(" sfbvsdjf " , API_END_POINTS.updateSubject);
          console.log(" sfbvsdjf " , API_END_POINTS.updateSubject.KEY);

          // Optional: Show error toast/notification
        },
      })
    );
  }else {
    dispatch(
      httpRequest({
        key: API_END_POINTS.createSubject.KEY, // ✅ check spelling
        data: { title: currentValue },

        onSuccess: () => {
          fetchSubjects();
          setIsModalOpen(false);
        },

        onError: (err) => {
          console.log("Create Error:", err);
        },
      })
    );
  }
};

  // ✅ DELETE
  const removeSubject = (idx) => {
    const id = subjects[idx]._id;
    dispatch(
      httpRequest({
        key: API_END_POINTS.deleteSubject.KEY,
        params: { id },
        onSuccess: () => {
          fetchSubjects();
        },
      })
    );
  };

  // 🔍 Search
  const filteredSubjects = subjects.filter((sub) =>
    sub.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={styles.container}>
      <div style={styles.bgGradient}></div>
      
      <div style={styles.headerArea}>
        <div style={styles.headerMain}>
          <div>
            <div style={styles.badge}>Management Console</div>
            <h1 style={styles.title}>Subjects</h1>
            <p style={styles.subtitle}>Create and manage your course curriculum</p>
          </div>
          <button onClick={() => toggleModal()} style={styles.addButton}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add New
          </button>
        </div>

        {/* Search Bar with Glass Effect */}
        <div style={styles.searchWrapper}>
          <svg style={styles.searchIcon} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            placeholder="Search subjects by title..."
            style={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* LIST SECTION */}
      <div style={styles.grid}>
        {filteredSubjects.length > 0 ? (
          filteredSubjects.map((sub, index) => {
            const actualIndex = subjects.findIndex((s) => s._id === sub._id);
            return (
              <div key={sub._id} style={styles.card}>
                <div style={styles.cardInfo}>
                  <div style={styles.iconBox}>
                    {sub.title.charAt(0).toUpperCase()}
                    <div style={styles.iconGlow}></div>
                  </div>
                  <div>
                    <span style={styles.subjectText}>{sub.title}</span>
                    <span style={styles.subjectMeta}>Active Subject</span>
                  </div>
                </div>

                <div style={styles.actions}>
                  <button onClick={() => toggleModal(actualIndex)} style={styles.editBtn}>
                    Edit
                  </button>
                  <button onClick={() => removeSubject(actualIndex)} style={styles.deleteBtn}>
                    Delete
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div style={styles.noData}>No subjects found matching your search.</div>
        )}
      </div>

      {/* MODAL SECTION */}
      {isModalOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h3>{editIdx !== null ? "Update Subject" : "Create Subject"}</h3>
              <button onClick={() => setIsModalOpen(false)} style={styles.closeBtn}>✕</button>
            </div>
            
            <div style={styles.modalBody}>
              <label style={styles.label}>Subject Title</label>
              <input
                autoFocus
                style={styles.modalInput}
                value={currentValue}
                onChange={(e) => setCurrentValue(e.target.value)}
                placeholder="e.g. Mathematics"
                onKeyPress={(e) => e.key === "Enter" && saveSubject()}
              />
            </div>

            <div style={styles.modalFooter}>
              <button onClick={() => setIsModalOpen(false)} style={styles.cancelBtn}>Cancel</button>
              <button onClick={saveSubject} style={styles.saveBtn}>
                {editIdx !== null ? "Save Changes" : "Confirm & Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "0 20px 40px 20px",
    minHeight: "100vh",
    backgroundColor: "#f4f7fe",
    fontFamily: "'Inter', sans-serif",
    position: "relative",
  },
  bgGradient: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "320px",
    zIndex: 0,
  },
  headerArea: {
    position: "relative",
    zIndex: 1,
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "20px",
    marginBottom: "30px",
background: "linear-gradient(135deg, #4338ca 0%, #6366f1 100%)",
borderRadius: "20px",

  },
  headerMain: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    marginTop: "20px"

  },
  badge: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: "#fff",
    padding: "5px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    display: "inline-block",
    marginBottom: "10px",
    backdropFilter: "blur(5px)",
  },
  title: { fontSize: "32px", fontWeight: "800", color: "#fff", margin: 0 },
  subtitle: { color: "rgba(255, 255, 255, 0.8)", fontSize: "15px", marginTop: "5px" },
  addButton: {
    backgroundColor: "#fff",
    color: "#4338ca",
    border: "none",
    padding: "12px 24px",
    borderRadius: "14px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s",
  },
  searchWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(10px)",
    borderRadius: "16px",
    padding: "0 18px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  searchIcon: { color: "#fff", opacity: 0.7 },
  searchInput: {
    width: "100%",
    padding: "15px 12px",
    backgroundColor: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "16px",
    outline: "none",
  },
  grid: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    maxWidth: "900px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
  },
  card: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 24px",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
    border: "1px solid #eef2f6",
    transition: "all 0.3s ease",
  },
  cardInfo: { display: "flex", alignItems: "center", gap: "18px" },
  iconBox: {
    width: "48px",
    height: "48px",
    background: "linear-gradient(135deg, #6366f1, #4338ca)",
    color: "#fff",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "700",
    position: "relative",
    overflow: "hidden",
  },
  iconGlow: {
    position: "absolute",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "radial-gradient(circle at top left, rgba(255,255,255,0.3), transparent)",
  },
  subjectText: { fontSize: "17px", fontWeight: "700", color: "#1e293b", display: "block" },
  subjectMeta: { fontSize: "12px", color: "#94a3b8" },
  actions: { display: "flex", gap: "10px" },
  editBtn: {
    backgroundColor: "#f1f5f9",
    color: "#475569",
    border: "none",
    padding: "8px 16px",
    borderRadius: "10px",
    fontWeight: "600",
    cursor: "pointer",
  },
  deleteBtn: {
    backgroundColor: "#fff1f2",
    color: "#e11d48",
    border: "none",
    padding: "8px 16px",
    borderRadius: "10px",
    fontWeight: "600",
    cursor: "pointer",
  },
  noData: { textAlign: "center", padding: "40px", color: "#64748b" },
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(15, 23, 42, 0.4)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
  },
  modal: {
    backgroundColor: "#fff",
    width: "400px",
    borderRadius: "24px",
    padding: "30px",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  closeBtn: { background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: "#94a3b8" },
  label: { fontSize: "14px", fontWeight: "600", color: "#64748b", marginBottom: "8px", display: "block" },
  modalInput: {
    width: "100%",
    padding: "14px",
    borderRadius: "12px",
    border: "2px solid #e2e8f0",
    fontSize: "16px",
    outline: "none",
    boxSizing: "border-box",
  },
  modalFooter: { display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "25px" },
  cancelBtn: { background: "none", border: "none", color: "#94a3b8", fontWeight: "600", cursor: "pointer" },
  saveBtn: {
    backgroundColor: "#4338ca",
    color: "#fff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "12px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(67, 56, 202, 0.3)",
  },
};

export default Subject;